interface Config {
  baseApiUrl: string;
  googleClientId: string;
}

export const config: Config = {
  baseApiUrl: process.env.REACT_APP_BASE_URL as string,
  googleClientId: process.env.REACT_APP_GOOGLE_SSO_CLIENT_ID as string,
};
